export const getProductSeries: string = `
  mutation getProductSeries($sku: String!, $count: Int = 15) {
     getProductSeries(sku: $sku, count: $count) {
      items {
        id
        sku
        name
        stock_status
        url_key
        stock_status
        only_x_left_in_stock
        tarneaeg
        availability_in_stores {
          qty
          source_name
          source_code
          status
        }
        url_rewrites {
          url
        }
        categories {
          uid
          name
          url_suffix
          url_path
          breadcrumbs {
            category_name,
            category_url_path
          }
        }
        available_price_tiers {
          discount {
            amount_off
            percent_off
          }
          final_price {
            currency
            value
          }
          quantity
        }
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
        }
        image {
          url
          position
          disabled
          label
        }
      }
    }
  }
`
